import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  bannerContainer: {
    ...Commons.coverBackground,
    display: "flex",
    width: "100%",
    position: "relative",
    borderRadius: 50,
    overflow: "hidden",
    animation: "$neonBgLoop 3s linear infinite",
    gap: 30,
    padding: "60px 18px",
    backgroundColor: colors.black,
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    margin: "30px 0 60px 0",
    zIndex: 1,
    [Commons.midQuery]: {
      borderRadius: 24,
      flexDirection: "column",
      padding: "12px",
    },
  },
  containerProfileImage: {
    ...Commons.flexCenter,
    position: "relative",
    backgroundColor: colors.black,
    borderRadius: "50%",
    width: 180,
    height: 180,
    animation: "$neonBgLoop 3s linear infinite",
    margin: 0,
    overflow: "hidden",
    [Commons.smallQuery]: {
      width: 120,
      height: 120,
    },
  },
  profileImage: {
    width: "100%",
    height: "100%",
  },
  bgWhite: {
    backgroundColor: colors.white,
    width: "100%",
    objectFit: "cover",
  },
  containerInfo: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    borderRadius: 24,
    position: "relative",
    padding: "24px 12px",
  },
  nameProfile: {
    position: "relative",
    color: colors.white,
    fontSize: 36,
    textAlign: "center",
    margin: "0 0 12px 0",
    [Commons.smallQuery]: {
      fontSize: 30,
    },
  },
  descriptionProfile: {
    color: colors.white,
    fontSize: 18,
    textAlign: "center",
    whiteSpace: "break-spaces",
    margin: 0,
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  ctaProfile: {
    ...Commons.defaultButton,
    backgroundColor: colors.orange,
    color: colors.white,
    fontSize: 18,
    borderRadius: 12,
    padding: "6px 12px",
    textAlign: "center",
    margin: "0 auto",
    marginTop: 18,
    display: "block",
    fontWeight: "600",
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  rowSocialProfile: {
    ...Commons.flexColumn,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.black,
    gap: 18,
    padding: 12,
    borderRadius: 18,
    "& svg": {
      color: colors.orange,
      fontSize: 36,
      [Commons.midQuery]: {
        fontSize: 32,
      },
    },
    "& a:hover svg": {
      color: colors.white,
    },
    [Commons.midQuery]: {
      width: "100%",
      padding: "12px 0",
      borderRadius: "18px 18px 0 0",
      margin: "0 0 -12px 0",
      flexDirection: "row",
    },
  },
  label: {
    color: colors.white,
    fontSize: 36,
    fontWeight: 600,
    margin: "0 0 18px 0",
    position: "relative",
    [Commons.smallQuery]: {
      fontSize: 20,
    },
  },
  moreButton: {
    textDecoration: "none",
    "& div": {
      ...Commons.defaultButton,
      color: colors.white,
      backgroundColor: colors.primary,
      borderRadius: 18,
      padding: "6px 18px",
      fontWeight: 700,
    },
  },
  containerListPlayer: {
    position: "relative",
    width: "100%",
    gap: 60,
    [Commons.smallQuery]: {
      gap: 18,
    },
  },
  itemPlayer: {
    width: "calc((100% / 3) - 40px)",
    [Commons.smallQuery]: {
      width: "calc((100% / 2) - 12px)",
    },
  },
  itemImgPlayer: {
    aspectRatio: "2 / 1",
    position: "relative",
    borderRadius: 18,
    boxShadow: `0 0 30px 10px ${colors.orange}30`,
    overflow: "hidden",
    width: "100%",
    cursor: "pointer",
  },
  itemNamePlayer: {
    color: colors.white,
    margin: "12px 0 6px 0",
    fontSize: 18,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  itemDescriptionPlayer: {
    color: colors.white,
    margin: 0,
    fontSize: 18,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  iconPlayer: {
    position: "absolute",
    width: 90,
    height: 90,
    [Commons.smallQuery]: {
      width: 60,
      height: 60,
    },
  },
  overlayPlayer: {
    ...Commons.flexCenter,
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.75)",
    left: 0,
    top: 0,
    transition: "all 0.3s",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.25)",
    },
  },
  imageVideo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  newBadge: {
    position: "absolute",
    top: 12,
    left: 12,
    backgroundColor: colors.primary,
    color: colors.white,
    borderRadius: 12,
    padding: "6px 12px",
    fontSize: 18,
    boxShadow: colors.shadowWhite,
    fontWeight: 600,
    [Commons.smallQuery]: {
      fontSize: 12,
    },
  },
  iconWaiting: {
    ...Commons.flexCenter,
    position: "absolute",
    top: 12,
    right: 12,
    backgroundColor: colors.blue,
    color: colors.white,
    borderRadius: "50%",
    boxShadow: colors.shadowWhite,
    width: 36,
    height: 36,
    aspectRatio: "1 / 1",
    "& svg": {
      fontSize: 24,
    },
    [Commons.midQuery]: {
      bottom: 12,
      left: 12,
      top: "unset",
      right: "unset",
      width: 36,
      height: 36,
      "& svg": {
        fontSize: 24,
      },
    },
  },
  "@keyframes neonBgLoop": {
    "0%": {
      boxShadow: `0 0 50px 3px ${colors.orange}30`,
    },
    "50%": {
      boxShadow: `0 0 50px 3px ${colors.orange}`,
    },
    "100%": {
      boxShadow: `0 0 50px 3px ${colors.orange}30`,
    },
  },
});

export default styles;
